export default function Footer() {
  return (
    <footer className="relative bg-secondary-900 text-background-200 pt-16 pb-8">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-tools-fill text-xl"></i>
              </div>
              <div>
                <div className="font-heading font-bold text-lg text-background-50">
                  Techy<span className="text-primary-500">Bootcamp</span>
                </div>
                <div className="text-[10px] uppercase tracking-[0.18em] font-mono text-background-400">
                  Tech Trade School
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-sm text-background-300">
              Hands-on training in the tech skills companies are hiring for. Tools included.
              Laptop included. Career support included.
            </p>
            <div className="mt-6 space-y-3">
              <a
                href="tel:8888663428"
                className="flex items-center gap-3 text-background-100 hover:text-primary-400 transition-colors cursor-pointer"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5">
                  <i className="ri-phone-fill text-primary-400"></i>
                </span>
                <span className="font-semibold">888-866-3428</span>
              </a>
              <a
                href="mailto:admissions@techybootcamp.com"
                className="flex items-center gap-3 text-background-300 hover:text-background-100 transition-colors cursor-pointer"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5">
                  <i className="ri-mail-line"></i>
                </span>
                <span className="text-sm">admissions@techybootcamp.com</span>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-widest">
              <a href="#programs" className="cursor-pointer">Programs</a>
            </h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#programs" className="hover:text-primary-400 transition-colors cursor-pointer">Wire &amp; Crimping</a></li>
              <li><a href="#programs" className="hover:text-primary-400 transition-colors cursor-pointer">Networks &amp; IT</a></li>
              <li><a href="#programs" className="hover:text-primary-400 transition-colors cursor-pointer">Security Systems</a></li>
              <li><a href="#programs" className="hover:text-primary-400 transition-colors cursor-pointer">Fire &amp; Alarm</a></li>
              <li><a href="#programs" className="hover:text-primary-400 transition-colors cursor-pointer">Computers &amp; Hardware</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-widest">School</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#included" className="hover:text-primary-400 transition-colors cursor-pointer">What's Included</a></li>
              <li><a href="#path" className="hover:text-primary-400 transition-colors cursor-pointer">How It Works</a></li>
              <li><a href="#outcomes" className="hover:text-primary-400 transition-colors cursor-pointer">Career Outcomes</a></li>
              <li><a href="#faq" className="hover:text-primary-400 transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#apply" className="hover:text-primary-400 transition-colors cursor-pointer">Apply</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-widest">For Employers</h4>
            <p className="text-sm text-background-300 leading-relaxed">
              Hiring low-voltage, network, security, or fire alarm techs? Our graduates are
              job-ready on day one. Let's talk about your pipeline.
            </p>
            <a
              href="tel:8888663428"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-phone-fill"></i> Hire Our Grads
            </a>

            <div className="mt-6 flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-fill"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50/5 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-fill"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-400">
          <p>© {new Date().getFullYear()} TechyBootcamp. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-background-100 transition-colors cursor-pointer">Privacy</a>
            <a href="#" className="hover:text-background-100 transition-colors cursor-pointer">Terms</a>
            <a href="#" className="hover:text-background-100 transition-colors cursor-pointer">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}